import { InputNumber } from 'antd';
import {
  getCompareReportExel,
  getFetchDistictGrades,
} from 'clients/dashboardClients';
import { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { useApiLoaderStore } from 'store/apiLoderStore';
import { useFilterStore } from 'store/filterStore';
import { useNewStore } from 'store/newStore';
import { useToastStore } from 'store/toastStore';
import styles from './exportFileDialogue.module.scss';

const reportsType = [
  // { label: 'By Entity', value: 'byEntity' },
  { label: 'By School', value: 'bySchool' },
];
const bySchoolReportsTemplate = [
  // { label: 'Summary Report', value: 'summaryReports' },
  { label: 'Compare report', value: 'compareReports' },
  { label: 'Compare survey report', value: 'compareSurveyReports' },
  { label: 'Compare statistics report', value: 'compareStatisticsReports' },
  // { label: 'Detail report', value: 'detailReports' },
];
const byEntityReportsTemplate = [
  { label: 'Summary report', value: 'summaryReports' },
];

type ExportFileDialogueProps = {
  setIsOpen: any;
  startDate: any;
  endDate: any;
};

export default function ExportFileDialogue(props: ExportFileDialogueProps) {
  const { setIsOpen, startDate, endDate } = props;
  const [
    selectedDataSouce,
    setCompareSurveyReportDrawerIsOpen,
    setCompareStatisticsReportDrawerIsOpen,
    reportType,
    setReportType,
    ReportTemplate,
    setReportTemplate,
    lowerLimit,
    setLowerLimit,
    higherLimit,
    setHigherLimit,
    setDistinctGrades,
  ] = useNewStore((state) => [
    state.selectedDataSouce,
    state.setCompareSurveyReportDrawerIsOpen,
    state.setCompareStatisticsReportDrawerIsOpen,
    state.reportType,
    state.setReportType,
    state.ReportTemplate,
    state.setReportTemplate,
    state.lowerLimit,
    state.setLowerLimit,
    state.higherLimit,
    state.setHigherLimit,
    state.setDistinctGrades,
  ]);
  const filterDto = useFilterStore((state) => state.filterDto);
  const showToast = useToastStore((state) => state.showToast);
  const showLoader = useApiLoaderStore((state) => state.showLoader);
  useEffect(() => {
    const filterParams = {
      selectedSessionNames: filterDto ? filterDto.selectedSessionNames : [],
      selectedCountries: filterDto ? filterDto.selectedCountries : [],
      selectedStates: filterDto ? filterDto.selectedStates : [],
      selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
      selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
      selectedClusters: filterDto ? filterDto.selectedClusters : [],
      selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
      selectedSchoolIds: filterDto ? filterDto.selectedSchoolIds : [],
      selectedGrades: filterDto ? filterDto.selectedGrades : [],
      startDate: startDate.unix(),
      endDate: endDate.unix(),
      dataSource: selectedDataSouce,
    };
    getFetchDistictGrades(filterParams, showToast).then((response) => {
      if (response) {
        let rowMap = new Map();
        response.forEach((row: any) => {
          const grade = row.grade;
          const subject = row.subject;
          const surveyId = row.surveyId;
          if (!rowMap.has(grade)) {
            rowMap.set(grade, new Map());
          }
          let gradeObject = rowMap.get(grade);
          if (!gradeObject.has(subject)) {
            gradeObject.set(subject, []);
          }
          let surveyIdArray = gradeObject.get(subject);
          surveyIdArray.push(surveyId);
        });
        setDistinctGrades(rowMap);
      }
    });
  }, [
    filterDto,
    showToast,
    setDistinctGrades,
    startDate,
    endDate,
    selectedDataSouce,
  ]);
  const onLowerRangeChange = (value: number) => {
    setLowerLimit(value);
  };

  const onHigherRangeChange = (value: number) => {
    setHigherLimit(value);
  };

  function onClose() {
    setIsOpen(false);
  }

  const onDownloadButtonClicked = () => {
    onClose();
    if (ReportTemplate === 'compareReports') {
      const body = {
        selectedSessionNames: filterDto ? filterDto.selectedSessionNames : [],
        selectedCountries: filterDto ? filterDto.selectedCountries : [],
        selectedStates: filterDto ? filterDto.selectedStates : [],
        selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
        selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
        selectedClusters: filterDto ? filterDto.selectedClusters : [],
        selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
        selectedSchoolIds: filterDto ? filterDto.selectedSchoolIds : [],
        selectedGrades: filterDto ? filterDto.selectedGrades : [],
        lowerLimit: lowerLimit,
        upperLimit: higherLimit,
        startDate: startDate.unix(),
        endDate: endDate.unix(),
        dataSource: selectedDataSouce,
      };
      showLoader(true);
      getCompareReportExel(body, showToast).then((response: any) => {
        showLoader(false);
        if (response) {
          response.blob().then((blob: any) => {
            if (blob && blob.size > 0) {
              const fileURL = window.URL.createObjectURL(blob);
              const elem = document.createElement('a');
              elem.href = fileURL;
              elem.download = 'report.xlsx';
              document.body.appendChild(elem);
              elem.click();
              document.body.removeChild(elem);
            }
          });
        }
      });
    }
    if (ReportTemplate === 'compareSurveyReports') {
      setCompareSurveyReportDrawerIsOpen(true);
    }
    if (ReportTemplate === 'compareStatisticsReports') {
      setCompareStatisticsReportDrawerIsOpen(true);
    }
  };
  return (
    <Modal
      show={true}
      onHide={() => setIsOpen(false)}
      className={styles.exportFileDialogueModule}
    >
      <Modal.Header className={styles.header}>
        <Modal.Title>EXPORT EXCEL</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.textCenter}>
          <div className={styles.displayFlex}>
            <label className={styles.reportTypeLabel}>ReportType :</label>
            <div className={styles.widthFifty}>
              <Select
                options={reportsType}
                placeholder="By School"
                onChange={(values: any) => setReportType(values!.value)}
              />
            </div>
          </div>
          <div className={styles.reportTemplateContainer}>
            <label className={styles.reportTemplateLabel}>
              ReportTemplate :
            </label>
            <div className={styles.widthFifty}>
              <Select
                options={
                  reportType === 'bySchool'
                    ? bySchoolReportsTemplate
                    : byEntityReportsTemplate
                }
                placeholder="Compare Report"
                onChange={(values: any) => setReportTemplate(values!.value)}
              />
            </div>
          </div>
          <div className={styles.performanceIndicatorContainer}>
            <label className={styles.performanceIndicatorLabel}>
              Performance Indicator :
            </label>
            <div className={styles.rangeContainer}>
              <div>{'0 <='}</div>
              <InputNumber
                min={0}
                max={75}
                className={styles.limitRange}
                value={lowerLimit}
                onChange={(value: number | null) => onLowerRangeChange(value!)}
              />
              <div>{'<='}</div>
              <InputNumber
                min={33}
                max={100}
                className={styles.limitRange}
                value={higherLimit}
                onChange={(value: number | null) => onHigherRangeChange(value!)}
              />
              <div>{'<= 100'}</div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={() => onDownloadButtonClicked()}>
          {ReportTemplate === 'compareReports' ? 'Download' : 'Next'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
